<h1 class="page-title">
    <i [class]="icon()"></i>
    {{ title() | translate }}@if (subtitle()) {
        | {{ subtitle() | translate }}
    }
</h1>
